import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React from "react"
import { Row, Col, Alert, Card, CardBody, Container } from "reactstrap"

// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// import images
import logoSm from "../../assets/images/logo-sm.png"

const CompletedSection = () => {
  return (
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={4}>
            <Card className="overflow-hidden">
              <div className="bg-primary">
                <div className="text-primary text-center p-4">
                  <h5 className="text-white font-size-20">Register</h5>
                  <p className="text-white-50">
                    Create an Account to start using our services.
                  </p>
                  <a href="#" className="logo logo-admin">
                    <img src={logoSm} height="24" alt="logo" />
                  </a>
                </div>
              </div>
              <CardBody className="p-4">
                <div className="p-3 mt-4">
                  <h3>
                    <Alert color="success">Registration successful</Alert>
                  </h3>
                  <center>
                    <Link to="/login" className="fw-medium text-centerrimary">
                      {" "}
                      Click here to Login
                    </Link>{" "}
                  </center>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
export default CompletedSection
